export default "__VITE_ASSET__U8Ukt0IGnmEjbjYZm7pfsQ__"